import * as React from 'react';
import { SVGProps } from 'react';
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" {...props}>
    <path
      fill="#241F20"
      fillRule="evenodd"
      d="M14.4 3.023 11.65 5.676H2.751v11.671h12.105v-4.26l2.751-2.652V20H0V3.023h14.4Z"
      clipRule="evenodd"
    />
    <path
      fill="#241F20"
      fillRule="evenodd"
      d="m8.717 12.004 9.338-9.003L20 4.877 8.717 15.756 6.772 13.88 3.659 10.88l1.946-1.876 3.112 3.001Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgComponent;
